// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import TermosDeUso from './TermosDeUso';
import Confirmacao from './Confirmacao';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<TermosDeUso />} />
        <Route path="/confirmacao" element={<Confirmacao />} />
      </Routes>
    </Router>
  );
}

export default App;